export default "__VITE_ASSET__W1nAG$D3__"